import React from 'react';
import { connect } from 'react-redux';
import { media } from 'helpers/MediaHelper';

import {
  createPurchaseOrderComment,
  getPurchaseOrder,
  approvePurchaseOrder,
  getPurchaseOrderStats,
  downloadPdf,
  denyPurchaseOrder,
  attachPurchaseOrderServiceRequest,
  removePurchaseOrderServiceRequest,
  attachPurchaseOrderProject,
  removePurchaseOrderProject,
} from 'actions/landlordPurchaseOrdersActions';
import { getUnits } from 'actions/landlordPropertiesActions';
import { postProject } from 'components/landlord_app/maintenance/projects/store/actions';

import styled from 'styled-components';

import { ApproverViewPurchaseOrder } from './ApproverViewPurchaseOrder';
import { RequesterViewPurchaseOrder } from './RequesterViewPurchaseOrder';

const StyledDrawerContainer = styled.div`
  align-items: center;
  height: 100%;
  ${media.mobile`
    overflow-y: scroll;
  `};
`;

export const ViewPurchaseOrderDrawer = connect(
  store => ({
    canApprovePurchaseOrder: store.userTypes.canApprovePurchaseOrder,
    glAccounts: store.landlordPurchaseOrders.glAccounts,
    expenseTypes: store.landlordPurchaseOrders.expenseTypes,
    vendors: store.landlordPurchaseOrders.vendors,
    properties: store.landlordProperties.properties,
    units: store.landlordProperties.units,
  }),
  {
    createPurchaseOrderComment,
    getPurchaseOrder,
    approvePurchaseOrder,
    getPurchaseOrderStats,
    getUnits,
    downloadPdf,
    denyPurchaseOrder,
    attachPurchaseOrderServiceRequest,
    removePurchaseOrderServiceRequest,
    postProject,
    attachPurchaseOrderProject,
    removePurchaseOrderProject,
  }
)(
  ({
    toggleViewPurchaseOrder,
    purchaseOrder,
    canApprovePurchaseOrder,
    createPurchaseOrderComment,
    getPurchaseOrder,
    glAccounts,
    expenseTypes,
    approvePurchaseOrder,
    getPurchaseOrderStats,
    fetchPurchaseOrders,
    denyPurchaseOrder,
    getUnits,
    downloadPdf,
    attachPurchaseOrderServiceRequest,
    removePurchaseOrderServiceRequest,
    vendors,
    postProject,
    attachPurchaseOrderProject,
    removePurchaseOrderProject,
    properties,
    units,
  }) => {
    if (!purchaseOrder) return null;
    const vendorFullInfo = vendors.find(vendor => {
      return vendor.id.toString() === purchaseOrder.external_vendor_id;
    });
    return (
      <StyledDrawerContainer>
        {canApprovePurchaseOrder ? (
          <ApproverViewPurchaseOrder
            purchaseOrder={purchaseOrder}
            toggleViewPurchaseOrder={toggleViewPurchaseOrder}
            glAccounts={glAccounts}
            expenseTypes={expenseTypes}
            approvePurchaseOrder={approvePurchaseOrder}
            getPurchaseOrder={getPurchaseOrder}
            getPurchaseOrderStats={getPurchaseOrderStats}
            fetchPurchaseOrders={fetchPurchaseOrders}
            downloadPdf={downloadPdf}
            getUnits={getUnits}
            createPurchaseOrderComment={createPurchaseOrderComment}
            denyPurchaseOrder={denyPurchaseOrder}
            attachPurchaseOrderServiceRequest={attachPurchaseOrderServiceRequest}
            removePurchaseOrderServiceRequest={removePurchaseOrderServiceRequest}
            vendorFullInfo={vendorFullInfo}
            postProject={postProject}
            attachPurchaseOrderProject={attachPurchaseOrderProject}
            removePurchaseOrderProject={removePurchaseOrderProject}
            properties={properties}
            units={units}
          />
        ) : (
          <RequesterViewPurchaseOrder
            purchaseOrder={purchaseOrder}
            toggleViewPurchaseOrder={toggleViewPurchaseOrder}
            createPurchaseOrderComment={createPurchaseOrderComment}
            getPurchaseOrder={getPurchaseOrder}
            getPurchaseOrderStats={getPurchaseOrderStats}
            fetchPurchaseOrders={fetchPurchaseOrders}
            approvePurchaseOrder={approvePurchaseOrder}
            getUnits={getUnits}
            attachPurchaseOrderServiceRequest={attachPurchaseOrderServiceRequest}
            removePurchaseOrderServiceRequest={removePurchaseOrderServiceRequest}
            postProject={postProject}
            attachPurchaseOrderProject={attachPurchaseOrderProject}
            removePurchaseOrderProject={removePurchaseOrderProject}
            properties={properties}
            units={units}
            downloadPdf={downloadPdf}
          />
        )}
      </StyledDrawerContainer>
    );
  }
);
